import { LoadingOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import apiService from "../../api/apiService";
import { saveAuthData } from "../../auth";

import copy from "../../assets/images/copyright.svg";
import EyeSvg from "../../assets/images/eye.svg";
import HotelJpeg from "../../assets/images/hotel.jpg";
import hotelProLogo from "../../assets/images/hotelProLogo.svg";
import LogoSvg from "../../assets/images/logo.svg";

import { Spin } from "antd";
import "./LoginPage.css";

const LoginPage = () => {
  localStorage.removeItem("token");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      toast.error("Please enter your credentials.", { autoClose: 1500 });
      return;
    }

    try {
      setIsLoading(true);

      const response = await apiService.post("/login/", { username, password });
      saveAuthData(response);

      const { role } = response;

      toast.success("Signed in successfully", { autoClose: 1000 });

      navigate(role === "manager" ? "/dashboard" : "/room");
    } catch (error) {
      console.error(error);
      toast.error(error?.detail || "Invalid credentials. Please try again.", {
        autoClose: 1500,
      });
      setIsLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />

      <div className="row main align-items-center ">
        {/* LEFT PANEL */}
        <div className="col-md-6 p-0 h-100 d-flex align-items-center">
          <div className="login-container w-100 ">
            <h2 className="fw-semibold mb-3 text-center text-md-start">
              Sign in to your account
            </h2>

            <form className="mt-4" onSubmit={handleLogin} autoComplete="on">
              {/* Username */}
              <div className="col-12 mt-3">
                <div className="inputbox input-icon-wrapper">
                  <UserOutlined className="input-icon" />
                  <input
                    type="text"
                    placeholder="Username"
                    className="hbox"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
              </div>

              {/* Password */}
              <div className="col-12 mt-3">
                <div className="inputbox input-icon-wrapper">
                  <LockOutlined className="input-icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    className="hbox"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <img
                    src={EyeSvg}
                    alt="Toggle Password"
                    className="eye"
                    onClick={togglePasswordVisibility}
                  />
                </div>
              </div>

              {/* Submit */}
              <div className="col-12 mb-5 mt-4">
                <button
                  type="submit"
                  className="btn buttons db"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <Spin
                      indicator={<LoadingOutlined spin />}
                      size="small"
                      style={{ color: "#fff" }}
                    />
                  ) : (
                    "Sign in"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div
          className="col-md-6 p-0 d-none d-md-block"
          style={{ height: "100vh" }}
        >
          <img
            src={HotelJpeg}
            alt="Hotel Background"
            className="probackimg h-100"
          />
          <div className="PA h-100 text-center text-white img-text-wrapper d-flex flex-column justify-content-around align-items-center">
            <div className="d-flex flex-column">
              <img
                src={hotelProLogo}
                alt="HotelPro Logo"
                width="150"
                height="150"
                className="mb-3 pro"
                style={{ marginTop: 160 }}
              />
              <span className="ps">Hotel PRO</span>
            </div>

            <div className="small-logo-text d-flex align-items-center">
              <img src={LogoSvg} alt="Small Logo" className="buss" />
              <div className="text-start ms-3">
                <p className="text-light fw-bold title">
                  The <span className="prodigyTec">Defcon Innovations</span>{" "}
                  product
                </p>
                <p className="copy">
                  <img src={copy} className="c" alt="Copyright" /> Defcon
                  Innovations Pvt. Ltd. All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
